import React, { useRef, useEffect,useMemo , useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from '../reducers/auth/auth.selectors';
import { InputGroup, FormControl } from 'react-bootstrap';
import { SendCommentIcon, SendCommentFilledIcon } from './Icons';
import { useTranslation } from 'react-i18next';
import { commentOnPost, fetchComments, replyOnComment } from '../reducers/feed/feed.actions';
import Avatar from './Avatar';
import Loader from './Loader';
import PostComment from './generic-components/post/PostComment';
import { END_SEEKING } from 'video-react/lib/actions/video';
import NoifyModal from './NotifyModal';

const Comments = ({ post }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [text, setText] = useState('');
  const commentInputRef = useRef();
  const [replyId, setReplyId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [rows, setrows] = useState(1);
  const [minRows, setminRows] = useState(1);
  const [maxRows, setmaxRows] = useState(4);
  const [lineValues, setvalue] = useState('');

  useEffect(() => {
    if (post) {
      if (!post.hasOwnProperty('commentsTotal')) {
        setIsLoading(true);
        dispatch(fetchComments(post.id)).finally(() => {
          setIsLoading(false);
        });
      }
    }
  }, [post]);
  const loadMoreComments = () => {
    setIsLoading(true);
    dispatch(fetchComments(post.id, Math.floor(post.comments.length / 10) + 1)).finally(() => {
      setIsLoading(false);
    });
  };

  const handleClose = () => {
    setIsOpen(false);
    window.location.reload();
  };
  // TODO ---- needs actual implementation


  const handleLineChange = (event) => {
    const textareaLineHeight = 20;


    const previousRows = event.target.rows;
    event.target.rows = minRows;
    // reset number of rows in textarea 
 

    const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      event.target.rows = currentRows;
    }

    if (currentRows >= maxRows) {
      event.target.rows = maxRows;
      event.target.scrollTop = event.target.scrollHeight;
    }
    setvalue(event.target.value)
    handleText(event.target.value)
    setrows(currentRows < maxRows ? currentRows : maxRows)

  };
   
  const emptyInput = text.trim().length === 0;
  const typingDirection = useMemo(() => {
   return emptyInput ? '' : 'auto';
   },[emptyInput]);

   const postComment = () => {
    if (isSubmitting || emptyInput) return;
    if (replyId) {
      dispatch(replyOnComment(replyId, text, post.id)).catch(err => {
        setIsOpen(true);
      });
      setReplyId(null);
      setrows(1);
      setText('');
      return;
    }

    if (!!text) {
      setIsSubmitting(true);
      dispatch(commentOnPost(post.id, text))
        .then(resp => {
          setIsSubmitting(false);
          setText('');
          setrows(1)
        })
        .catch(err => {
          setIsSubmitting(false);
          setIsOpen(true);
        });
    }
  };

  function pasteIntoInput(el, text) {
    el.focus();
    if (typeof el.selectionStart == "number"
      && typeof el.selectionEnd == "number") {
      var val = el.value;
      var selStart = el.selectionStart;
      el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd);
      el.selectionEnd = el.selectionStart = selStart + text.length;
    } else if (typeof document.selection != "undefined") {
      var textRange = document.selection.createRange();
      textRange.text = text;
      textRange.collapse(false);
      textRange.select();
    }
  }
  const replyClick = el => {
    let { nickname, name } = el.user;
    commentInputRef?.current.focus();
    setText('@' + (name) + '\n');
    setReplyId(el.id);
    setrows(2)
  };

  const replyHandler =(reply, el) => {
    const {name} = reply.user;
    commentInputRef?.current.focus();
    setText('@' + (name) + '\n');
    setReplyId(el.id);
    setrows(2)
  }

  const handleText = value => {
    if (!value) {
      setReplyId(null);
    }
    setText(value);
  };

  return (
    <div className="comments-container">
      <Loader isLoadin={isLoading && !post.comments} height={17} size={16}>
        {!!post.comments && post.commentsTotal > post.comments.length && (
          <div className="py-2 d-inline-block" style={{}}>
            <Loader isLoadin={isLoading} height={17} size={16}>
              <span className="text-light-gray cursor-pointer" onClick={loadMoreComments}>
                {t('View more comments')}
              </span>
            </Loader>
          </div>
        )}
        {!!post.comments &&
          post.comments.map((el, index) => <PostComment replyHandler={(reply) => replyHandler(reply, el)} replyClick={() => replyClick(el)} key={index} el={el} />)}

      </Loader>
      <NoifyModal
        show={isOpen}
        onHide={handleClose}
        customClass="notification-modal"
        Content={
          'The post or object that you were commenting on has been removed  by its owner and can no longer be commented on'
        }
        title={'Post has been removed'}
      />
      <div className="d-flex mt-3 add-comment-container">
        <Avatar
          user={user && user.name}
          style={{ fontSize: '10px' }}
          size={40}
          image={user.avatar}
          className="coment-avatar"
          isOnline={true}
        />
        <InputGroup className="comment-type-box">
          <FormControl
          className={'text-gray comment-input-container'}
            as="textarea"
            dir={typingDirection}
            ref={commentInputRef}
            id="text"
            name="text"
            autoComplete="off"
            maxLength={replyId ? 255 : 1000}
            rows={rows}
            value={text}
            disabled={isSubmitting}
            style={{ resize: 'none', border: 'none', color:'#fff'}}
            placeholder={t('Write a comment...')}
             onKeyDown={e => {
              if (e.keyCode == 13 && e.shiftKey) {

                pasteIntoInput(this, "\n");
                e.preventDefault();
              }

            }}
            onChange={e => {
              handleLineChange(e)
            }}
          />
        </InputGroup>
        <InputGroup.Append>
            <InputGroup.Text
              className="text-light-gray cursor-pointer comment-input-container-icon-container"
              onClick={postComment}
            >
              {emptyInput ? 
              <SendCommentIcon className={'comment-icon'}/> :
              <SendCommentFilledIcon className={'comment-icon'}/>}
            </InputGroup.Text>
          </InputGroup.Append>
      </div>
    </div>
  );
};

export default Comments;
